// 批改页面
import { sendLogById, sendLogClick } from './index'
console.log(sendLogClick)

export default {
  // 页面初始化
  initPageLogger(data) {
    sendLogById('smallfox-teacher_32', {
      ...data
    })
  },
  // 上课与批改-查看课程
  selCourseLogger(data) {
    sendLogClick('smallfox-teacher_25', {
      ...data
    })
  },
  // 上课与批改-批改
  correctBtnLogger(data) {
    sendLogClick('smallfox-teacher_23', {
      ...data
    })
  },
  // 批改详情页-未提交
  notSubmitLogger(data) {
    sendLogClick('smallfox-teacher_22', {
      ...data
    })
  },
  // 批改详情页-已批改
  correctedLogger(data) {
    sendLogClick('smallfox-teacher_21', {
      ...data
    })
  },
  // 待批改列表-去批改
  toCorrectLogger(data) {
    sendLogClick('smallfox-teacher_20', {
      ...data
    })
  },
  // 【答案】按钮
  answerBtn(data) {
    sendLogClick('smallfox-teacher_19', {
      ...data
    })
  },
  // 【对号】
  rightIcon(data) {
    sendLogClick('smallfox-teacher_18', {
      ...data
    })
  },
  // 【斜线】
  wrongIcon(data) {
    sendLogClick('smallfox-teacher_17', {
      ...data
    })
  },
  // 【清屏】
  clearCanvas(data) {
    sendLogClick('smallfox-teacher_16', {
      ...data
    })
  },
  // 【放大】
  zoomOut(data) {
    sendLogClick('smallfox-teacher_15', {
      ...data
    })
  },
  // 【缩小】
  zoomIn(data) {
    sendLogClick('smallfox-teacher_14', {
      ...data
    })
  },
  // 【旋转】
  rotate(data) {
    sendLogClick('smallfox-teacher_13', {
      ...data
    })
  },
  // 【提交批改】按钮
  submitCorrect(data) {
    sendLogClick('smallfox-teacher_7', {
      ...data
    })
  },

  // 1.5.5新增批改埋点
  // 备课配置-保存
  confCourse(data) {
    sendLogClick('smallfox-teacher_64', {
      ...data
    })
  },
  // 解锁课前学
  openCourseBefore(data) {
    sendLogClick('smallfox-teacher_65', {
      ...data
    })
  },
  // 解锁讲次
  openLesson(data) {
    sendLogClick('smallfox-teacher_66', {
      ...data
    })
  },
  // 批改-大对号
  rightIconBig(data) {
    sendLogClick('smallfox-teacher_53', {
      ...data
    })
  },
  // 批改-小对号
  rightIconSmall(data) {
    sendLogClick('smallfox-teacher_54', {
      ...data
    })
  },
  // 批改-文字输入
  inputTxt(data) {
    sendLogClick('smallfox-teacher_55', {
      ...data
    })
  },
  // 批改-圆圈
  circular(data) {
    sendLogClick('smallfox-teacher_56', {
      ...data
    })
  },
  // 批改-横线
  line(data) {
    sendLogClick('smallfox-teacher_57', {
      ...data
    })
  },
  // 批改-曲线
  curve(data) {
    sendLogClick('smallfox-teacher_58', {
      ...data
    })
  },
  // 批改-快捷评语
  fastComment(data) {
    sendLogClick('smallfox-teacher_59', {
      ...data
    })
  },
  // 批改-打分
  score(data) {
    sendLogClick('smallfox-teacher_60', {
      ...data
    })
  }
  // 1.5.5END
}